/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { MutableRefObject, useEffect } from "react";
import { TweenMax, Expo, gsap } from "gsap/all";
import "../../styles/Projects.css";
import ring from "../../images/ring_main.png";
import nameLogo from "../../images/name-logo.svg";
import { bgProjectPageAnimation } from "./helperAnimations";
import { motion } from "framer-motion";
import { Outlet, useNavigate } from "react-router-dom";
import BgLogo from "../../components/BgLogo";
import TransitionComp from "../../components/TransitionComp";
import menuItem1 from "../../images/project1/pathfinder1.JPG";
import menuItem2 from "../../images/project2/pathfinder1.JPG";
import menuItem3 from "../../images/project3/pathfinder1.JPG";
import menuItem4 from "../../images/project4/pathfinder1.JPG";
import anime from "animejs";
import { ArrowBack } from "react-ionicons";
function ProjectsPage() {
  const letterRef = React.useRef() as MutableRefObject<HTMLDivElement>;
  const menuItemRef1 = React.useRef() as MutableRefObject<HTMLDivElement>;

  const projects = [{
    title: "Pathfinder Algorithm Visualizer",
    name: "project1",
    src: menuItem1
  },{
    title: "DARKLOOK PORTFOLIO",
    name: "project2",
    src: menuItem2
  },{
    title: "Ecommerce Web Application",
    name: "project3",
    src: menuItem3
  },{
    title: "COVID 19 Tracker",
    name: "project4",
    src: menuItem4
  },]

  const navigate = useNavigate();
  useEffect(() => {
    bgProjectPageAnimation();
    const bgMain = (letterRef as MutableRefObject<HTMLDivElement>).current;
    if (typeof bgMain.textContent === "string") {
      anime.timeline().add({
        targets: ".project_header .project_item",
        opacity: [0, 1],
        translateY: [200, 0],
        translateZ: 0,
        easing: "easeOutExpo",
        duration: 2000,
        delay: (el, i) => 7000 + 40 * i,
      });
    }
  });

  useEffect(() => {
    // project list animation
    gsap
      .timeline()
      .set(".menu", { autoAlpha: 1 })
      .from(".menu__item-innertext", {
        delay: 1,
        duration: 0.85,
        xPercent: 25,
        yPercent: 125,
        stagger: 0.095,
        skewY: gsap.utils.wrap([-8, 8]),
        ease: "expo.out",
      })
      .set(".menu", { pointerEvents: "all" });

    gsap.defaults({
      duration: 0.55,
      ease: "expo.out",
    });

    const menuItems = menuItemRef1.current.querySelectorAll(".menu__item");

    menuItems.forEach((item) => {
      const imageWrapper = item.querySelector(".menu__item-image_wrapper");

      const imageWrapperBounds = imageWrapper?.getBoundingClientRect();
      let itemBounds = item.getBoundingClientRect();
      const onMouseEnter = () => {
        gsap.set(imageWrapper, {
          scale: 0.8,
          xPercent: 25,
          yPercent: 50,
          rotation: -15,
        });
        gsap.to(imageWrapper, {
          opacity: 1,
          scale: 1,
          yPercent: 0,
          rotation: 0,
        });
      };
      const onMouseLeave = () => {
        gsap.to(imageWrapper, {
          scale: 0.8,
          xPercent: 25,
          yPercent: 50,
          rotation: -15,
          opacity: 0,
        });
      };
      const onMouseMove = (props: any) => {
        const x = props.x;
        const y = props.y;
        if (imageWrapperBounds) {
          let yOffset = itemBounds.top / imageWrapperBounds?.height;
          yOffset = gsap.utils.mapRange(0, 1.5, -150, 150, yOffset);
          gsap.to(imageWrapper, {
            duration: 1.25,
            x: Math.abs(x - itemBounds.left) - imageWrapperBounds?.width / 1.55,
            y:
              Math.abs(y - itemBounds.top) -
              imageWrapperBounds?.height / 2 -
              yOffset,
          });
        }
      };

      const onClick = () => {
        console.log(item.id);
        navigate("/portfolio/" + item.id);
      };

      item.addEventListener("mouseenter", () => {
        onMouseEnter();
      });
      item.addEventListener("mouseleave", onMouseLeave);
      item.addEventListener("mousemove", onMouseMove);
      item.addEventListener("click", onClick);

      window.addEventListener("resize", () => {
        itemBounds = item.getBoundingClientRect();
      });
    });
  }, []);

  return (
    <>
      <TransitionComp children={<BgLogo />} />
      <div className="project_container">
        <div className="project_text-container"></div>
        <div className="project_text-wrapper">
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
          <div className="project_bg_text">
            Engineer Software FullStack Innovative TeamPlayer Agile React
          </div>
        </div>
        <div className="project_header" ref={letterRef}>
          <div className="project_item">
            <div className="homeLinkContainer">
              <div className="homeNavLink" onClick={() => navigate("/")}>
                <ArrowBack
                  color={"#6adb9d"}
                  style={{ marginBottom: "43px" }}
                  width="40px" 
                  title={"Options"}
                />
                <p style={{ fontSize: "26px", marginLeft: "30px" }}>
                  Back Home
                </p>
              </div>
            </div>

            <nav className="menu" ref={menuItemRef1}>
              {projects.map((project) => {
                return (
                  <div className="menu__item" id={project.name}>
                  <div className="menu__item-image_wrapper">
                    <div className="menu__item-image_inner">
                      <img src={project.src} alt="menu" />
                    </div>
                  </div>
                  <span className="menu__item-text">
                    <span className="menu__item-innertext">{project.title}</span>
                  </span>
                </div>
                )
              })}
              {/* <div className="menu__item" id="project1">
                <div className="menu__item-image_wrapper">
                  <div className="menu__item-image_inner">
                    <img src={menuItem1} alt="menu" />
                  </div>
                </div>
                <span className="menu__item-text">
                  <span className="menu__item-innertext">Zinjao</span>
                </span>
              </div>

              <div className="menu__item" id="project2">
                <div className="menu__item-image_wrapper">
                  <div className="menu__item-image_inner">
                    <img src={menuItem2} alt="menu" />
                  </div>
                </div>
                <span className="menu__item-text">
                  <span className="menu__item-innertext">Test2</span>
                </span>
              </div>

              <div className="menu__item" id="project3">
                <div className="menu__item-image_wrapper">
                  <div className="menu__item-image_inner">
                    <img src={menuItem3} alt="menu" />
                  </div>
                </div>
                <span className="menu__item-text">
                  <span className="menu__item-innertext">Test3</span>
                </span>
              </div>

              <div className="menu__item" id="project3">
                <div className="menu__item-image_wrapper">
                  <div className="menu__item-image_inner">
                    <img src={menuItem3} alt="menu" />
                  </div>
                </div>
                <span className="menu__item-text">
                  <span className="menu__item-innertext">Test3</span>
                </span>
              </div> */}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectsPage;
